import { Notifications } from "~/features/notifications/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const NotificationsPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlNotifications");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <Notifications /> : <Construction />;
};
